module.exports = __webpack_public_path__ + "static/media/ah-screen-2.1f30c9cb.png";